/* ============================================================
   SEARCH DISCOUNT WORLD — Theme JS
   Vanilla JS only. No dependencies.
   ============================================================ */

/* ── STICKY HEADER ── */
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener(
    'scroll',
    function () {
      header.classList.toggle('scrolled', window.scrollY > 6);
    },
    { passive: true }
  );
})();

/* ── CART COUNT UPDATER ── */
function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.js-cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(function () {});
}

/* ── CART TOAST ── */
function showToast(title) {
  var toast = document.getElementById('cart-toast');
  if (!toast) return;
  var titleEl = toast.querySelector('.cart-toast__title');
  if (titleEl) titleEl.textContent = title || '';
  toast.classList.add('cart-toast--visible');
  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(function () {
    toast.classList.remove('cart-toast--visible');
  }, 3200);
}

/* ── AJAX ADD TO CART ── */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.js-atc');
  if (!btn) return;

  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  var originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then(function (r) { return r.json(); })
    .then(function (item) {
      btn.textContent = '✓ Added!';
      btn.style.background = '#059669';
      updateCartCount();
      showToast(item.title);
      setTimeout(function () {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 2500);
    })
    .catch(function () {
      btn.textContent = 'Error — try again';
      btn.style.background = '';
      btn.disabled = false;
    });
});

/* ── WISHLIST (local storage) ── */
(function () {
  var STORAGE_KEY = 'sdw-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function updateWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('.js-wishlist').forEach(function (btn) {
      var id = btn.dataset.productId;
      btn.classList.toggle('saved', list.indexOf(id) !== -1);
      btn.setAttribute('aria-label', list.indexOf(id) !== -1 ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-wishlist');
    if (!btn) return;
    var id = btn.dataset.productId;
    if (!id) return;

    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    updateWishlistButtons();
  });

  updateWishlistButtons();
})();

/* ── PDP IMAGE GALLERY SWIPE ── */
(function () {
  var gallery = document.querySelector('.product-gallery');
  if (!gallery) return;

  var startX = null;
  var currentIdx = 0;
  var images = gallery.querySelectorAll('.product-gallery__slide');
  var dots   = gallery.querySelectorAll('.product-gallery__dot');
  var thumbs = gallery.querySelectorAll('.product-gallery__thumb');

  function goTo(idx) {
    images[currentIdx].classList.remove('active');
    if (dots[currentIdx])   dots[currentIdx].classList.remove('active');
    if (thumbs[currentIdx]) thumbs[currentIdx].classList.remove('active');

    currentIdx = Math.max(0, Math.min(idx, images.length - 1));

    images[currentIdx].classList.add('active');
    if (dots[currentIdx])   dots[currentIdx].classList.add('active');
    if (thumbs[currentIdx]) thumbs[currentIdx].classList.add('active');
  }

  gallery.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  }, { passive: true });

  gallery.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    if (dx < -40) goTo(currentIdx + 1);
    if (dx > 40)  goTo(currentIdx - 1);
    startX = null;
  });

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { goTo(i); });
  });
})();

/* ── PDP VARIANT SELECTOR + PRICE UPDATE ── */
(function () {
  var form = document.querySelector('.product-form');
  if (!form) return;

  var variantDataEl = document.getElementById('product-variants-json');
  if (!variantDataEl) return;
  var variantData  = JSON.parse(variantDataEl.textContent);

  var priceEl      = document.querySelector('.js-product-price');
  var compareEl    = document.querySelector('.js-product-compare');
  var savingsEl    = document.querySelector('.js-product-savings');
  var stickyPrice  = document.querySelector('.js-sticky-price');
  var variantInput = form.querySelector('[name="id"]');

  document.querySelectorAll('.js-variant-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      var variant   = variantData.find(function (v) { return v.id == variantId; });
      if (!variant || !variant.available) return;

      document.querySelectorAll('.js-variant-option').forEach(function (b) {
        b.classList.remove('selected');
      });
      btn.classList.add('selected');
      if (variantInput) variantInput.value = variantId;

      var price        = variant.price / 100;
      var comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : 0;
      var savings      = comparePrice > 0 ? (comparePrice - price).toFixed(2) : 0;

      if (priceEl)     priceEl.textContent = '$' + price.toFixed(2);
      if (compareEl)   compareEl.textContent = comparePrice > 0 ? '$' + comparePrice.toFixed(2) : '';
      if (savingsEl)   savingsEl.textContent = savings > 0 ? 'SAVE $' + savings : '';
      if (stickyPrice) stickyPrice.textContent = '$' + price.toFixed(2);
    });
  });
})();

/* ── PDP TAB SWITCHER ── */
(function () {
  document.querySelectorAll('.js-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.tab;
      document.querySelectorAll('.js-tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.js-tab-panel').forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.querySelector('.js-tab-panel[data-tab="' + target + '"]');
      if (panel) panel.classList.add('active');
    });
  });
})();

/* ── STICKY PDP CTA BAR (show when main CTA scrolls out) ── */
(function () {
  var mainCta   = document.querySelector('.product-info__cta');
  var stickyBar = document.querySelector('.sticky-atc');
  if (!mainCta || !stickyBar) return;

  var observer = new IntersectionObserver(
    function (entries) {
      stickyBar.classList.toggle('sticky-atc--visible', !entries[0].isIntersecting);
    },
    { threshold: 0 }
  );

  observer.observe(mainCta);
})();
